/* eslint-disable react/require-default-props */

import React from 'react';
import proptypes from 'prop-types';
const { string, func, bool, number, oneOf } = proptypes;
import {
  extend
} from '@thd-nucleus/data-sources';
import {
  PodSticker,
  PodSection,
  PodSpacer,
  ProductPod,
  ProductImage,
  ProductBadge,
  ProductSponsored,
  ProductRating,
  ProductATC,
  PodFooter
} from '@thd-olt-component-react/product-pod';
import { ProductSeeSimilarItems } from '@thd-olt-component-react/product-pod-group';
import { AddToList } from '@thd-olt-component-react/add-to-list';
import { FulfillmentPodShipping, FulfillmentPodStore } from '@thd-olt-component-react/fulfillment';
import { SuperSkuMiniSwatches } from '@thd-olt-component-react/super-sku';
import { Price } from '@thd-olt-component-react/price';
import { ProductHeader } from '@thd-olt-component-react/product-details';

export const CustomProductPod = ({
  itemId,
  storeId,
  position,
  onClick = () => {},
  parent = 'shopbyroom',
  brandPosition = 'inline',
  showSimilarItem = false,
  hidePriceBadge = false,
  hideLimitPerOrder = false,
  hideSavingsText = false,
  hideFulfillment = false,
  showStoreFulfillment = true,
  showDeliveryFulfillment = false,
  hideATC = false
}) => {

  return (
    <ProductPod
      itemId={itemId}
      storeId={storeId}
      analyticsData={{ parent, position }}
      render={(pod) => (
        <>
          <div className="sui-flex sui-justify-between sui-mb-2">
            <PodSection noPadding>
              <ProductBadge itemId={pod.itemId} storeId={storeId} />
            </PodSection>
            <PodSpacer padding={['TOP', 'RIGHT']}>
              <AddToList itemId={pod.itemId} showCount showIconButton />
            </PodSpacer>
          </div>
          <ProductImage
            itemId={pod.itemId}
            showSecondaryImage={pod.showSecondaryImage}
            onClick={onClick}
          />
          <PodSection columnAlign alignTop>
            <SuperSkuMiniSwatches
              itemId={pod.itemId}
              storeId={storeId}
              onChange={pod.onChange}
              onHover={pod.onSSKUHover}
            />
            <PodSpacer padding={['TOP', 'BOTTOM']}>
              <ProductHeader
                brand={brandPosition}
                itemId={pod.itemId}
                brandTitleMaxLine={4}
                disableShopThisCollection
                onClick={onClick}
              />
            </PodSpacer>
            <ProductRating itemId={pod.itemId} />
            <PodSpacer minHeight="60px" disable={pod.productSubType === 'HDQC'}>
              <Price
                itemId={pod.itemId}
                large={false}
                storeId={storeId}
                displayEachUom={false}
                hideBadge={hidePriceBadge}
                hideLimitPerOrder={hideLimitPerOrder}
                hideSavingsText={hideSavingsText}
                onSavingsCenterToggle={pod.onSavingsCenterToggle}
                hideForProductTypes={['HDQC']}
              />
            </PodSpacer>
          </PodSection>
          <PodFooter>
            {!hideFulfillment && (
              <PodSpacer minHeight="124px" disable={pod.productSubType === 'HDQC'}>
                {showStoreFulfillment && (
                  <FulfillmentPodStore itemId={pod.itemId} storeId={storeId} hideForChooseYourOptions />
                )}
                {showDeliveryFulfillment && (
                  <FulfillmentPodShipping itemId={pod.itemId} storeId={storeId} />
                )}
              </PodSpacer>
            )}
            {!hideATC && (
              <PodSpacer>
                <ProductATC
                  itemId={pod.itemId}
                  storeId={storeId}
                  checkGeneric
                  outline
                />
              </PodSpacer>
            )}
            <ProductSeeSimilarItems
              itemId={pod.itemId}
              position={position}
              productPodRef={pod.ref}
              storeId={storeId}
              showSimilarInStock={showSimilarItem}
            />
          </PodFooter>
        </>
      )}
    />
  );
};

CustomProductPod.propTypes = {
  itemId: string.isRequired,
  storeId: string.isRequired,
  position: number.isRequired,
  onClick: func,
  brandPosition: oneOf(['above', 'below', 'hidden', 'inline']),
  parent: string,
  hidePriceBadge: bool,
  hideLimitPerOrder: bool,
  hideSavingsText: bool,
  showSimilarItem: bool,
  showStoreFulfillment: bool,
  hideFulfillment: bool,
  showDeliveryFulfillment: bool,
  hideATC: bool
};

CustomProductPod.dataModel = extend({},
  ProductPod,
  ProductImage,
  AddToList,
  Price,
  SuperSkuMiniSwatches,
  ProductATC,
  ProductRating,
  ProductHeader,
  ProductBadge,
  ProductSponsored,
  FulfillmentPodStore,
  FulfillmentPodShipping
);
